import EmblaCarousel from "embla-carousel"
import Autoplay from "embla-carousel-autoplay"
import { addPrevNextBtnsClickHandlers } from "./EmblaCarouselArrowButtons"
import { addDotBtnsAndClickHandlers } from "./EmblaCarouselDotButton"

function initializeCarousel(emblaRoot) {
  emblaRoot.classList.add("is-not-ready")

  const viewportNode = emblaRoot.querySelector(".embla__viewport")
  const prevBtnNode = emblaRoot.querySelector(".embla__button--prev")
  const nextBtnNode = emblaRoot.querySelector(".embla__button--next")
  const dotsNode = emblaRoot.querySelector(".embla__dots")
  const homeBtn = emblaRoot.querySelector(".home-button")
  const disappearButton = emblaRoot.querySelector(".arrow-disappear-button")

  const shouldLoop = emblaRoot.dataset.loop !== "false"
  const OPTIONS = { loop: shouldLoop }
  // 預設開啟自動輪播，除非是false
  const shouldAutoplay = emblaRoot.dataset.autoplay !== "false"

  const plugins = shouldAutoplay ? [Autoplay({ delay: 3000, stopOnInteraction: true })] : []

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS, plugins)

  // 讓按鈕固定在中間照片左右兩側
  function positionArrows() {
    if (prevBtnNode && nextBtnNode && homeBtn) {
      const slide = document.querySelector(".embla__slide")
      const slideRect = slide.getBoundingClientRect()

      prevBtnNode.style.left = `${(window.innerWidth - slideRect.width - prevBtnNode.offsetWidth) / 2}px`
      nextBtnNode.style.right = `${(window.innerWidth - slideRect.width - prevBtnNode.offsetWidth) / 2}px`

      prevBtnNode.classList.remove("invisible")
      nextBtnNode.classList.remove("invisible")
    }
  }
  // 到底自動隱藏按鈕
  function toggleArrowVisibility(emblaApi, prevBtn, nextBtn) {
    const canScrollPrev = emblaApi.canScrollPrev()
    const canScrollNext = emblaApi.canScrollNext()

    if (prevBtn) prevBtn.classList.toggle("!hidden", !canScrollPrev)
    if (nextBtn) nextBtn.classList.toggle("!hidden", !canScrollNext)
  }

  emblaApi.on("init", () => {
    const container = emblaRoot.querySelector(".embla__container")
    container.classList.remove("is-not-ready")

    if (emblaRoot.id === "brands_carousel_one") {
      setTimeout(() => {
        emblaRoot.classList.add("carousel-ready")
      }, 100)
    }

    if (disappearButton) {
      toggleArrowVisibility(emblaApi, prevBtnNode, nextBtnNode)
    }
  })
  emblaApi.on("select", () => {
    if (disappearButton) {
      toggleArrowVisibility(emblaApi, prevBtnNode, nextBtnNode)
    }
  })

  let removePrevNextBtnsClickHandlers = () => { }
  if (prevBtnNode && nextBtnNode) {
    removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)
  }

  let removeDotBtnsAndClickHandlers = () => { }
  if (dotsNode) {
    removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode)
  }
  positionArrows()
  window.addEventListener("resize", positionArrows)

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers)
  emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
}

document.addEventListener("DOMContentLoaded", function () {
  const homeBannerCarousel = document.querySelector("#home_main_carousel")
  if (homeBannerCarousel) {
    initializeCarousel(homeBannerCarousel)
  }
})

document.addEventListener("turbo:load", function () {
  const emblaNode = document.querySelectorAll(".embla")
  if (!emblaNode.length) return

  // 優先初始化首頁 banner carousel（如果還沒初始化）
  const homeBannerCarousel = document.querySelector("#home_main_carousel")
  if (homeBannerCarousel && homeBannerCarousel.querySelector(".embla__container.is-not-ready")) {
    initializeCarousel(homeBannerCarousel)
  }

  // 然後初始化其他 carousel
  emblaNode.forEach((emblaRoot) => {
    if (emblaRoot.id === "home_main_carousel") return
    initializeCarousel(emblaRoot)
  })
})
